import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from "@angular/router";
import { SharedComponentsModule } from "../../../shared/module/shared-components.module";
import { getKpiAllCompaniesUrl, getKpiCompanyMetricsUrl, KPI_URLS } from "../../module/kpi-module-routing.module";
import { TabType } from "../../../shared/component/tabs-with-counter/tabs-with-counter.component";

@Component({
  selector: 'app-kpi-companies-main',
  standalone: true,
  imports: [
    RouterOutlet,
    SharedComponentsModule,
  ],
  templateUrl: './kpi-companies-main.component.html',
  styleUrl: './kpi-companies-main.component.scss',
})
export class KpiCompaniesMainComponent {
  readonly TabType = TabType;
  tabs = new Tabs(this.router.url);

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {
  }

  switchTab(tab: typeof KpiCompanyTab[number]): void {
    if (tab === this.tabs.selected) {
      return;
    }
    this.tabs.selected = tab;
    this.tabs.updateSelectedIndex();
    switch (tab) {
      case 'Company':
        this.router.navigate(
          [getKpiCompanyMetricsUrl()],
          { queryParams: this.route.snapshot.queryParams });
        break;
      case 'All companies':
        this.router.navigate(
          [getKpiAllCompaniesUrl()],
          { queryParams: this.route.snapshot.queryParams });
        break;
    }
  }
}


class Tabs {
  all: typeof KpiCompanyTab[number][];
  selected: typeof KpiCompanyTab[number] = 'Company';
  selectedIndex: number;

  constructor(url: string) {
    this.initTabs(url);
  }

  initTabs(url: string): void {
    this.all = ['Company', 'All companies'];
    this.defineTabAfterRefresh(url);
  }

  defineTabAfterRefresh(url: string): void {
    this.selected = this.getTabByURL(url);
    this.updateSelectedIndex();
  }

  getTabByURL(url: string): typeof KpiCompanyTab[number] {
    if (!url) {
      return;
    }
    if (url.includes(KPI_URLS._companyMetrics)) {
      return 'Company';
    }
    if (url.includes(KPI_URLS._companies)) {
      return 'All companies';
    }
    return null;
  }

  updateSelectedIndex(): void {
    this.selectedIndex = this.all.indexOf(this.selected ?? 'Company');
  }
}

const KpiCompanyTab = ['Company', 'All companies'] as const;
